import { MatchedProfile, Shortlist } from "PFTypes";

export type MatchReason = string;

export type Match = MatchedProfile & {
  shortlist: Pick<Shortlist, "id" | "state" | "applicableCustomValues"> | null;
};

export enum MatchFetchState {
  Pending = "pending",
  Synced = "synced",
  Error = "error",
  Timeout = "timeout"
}
